<div class="dialog-container">
  <div class="dialog-header">
    @if (step === 1) {
      <h1 class="dialog-title">Importador de Categorias Financeiras</h1>
    }
    @if (step === 2) {
      <h1 class="dialog-title">Pré-visualização da importação</h1>
    }

    <button mat-icon-button (click)="cancelar()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (step === 1) {
    <div class="dialog-content">
      <div class="actions-row">
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" hidden />
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="fileInput.click()"
          [disabled]="isLoading">
          @if (!isLoading) {
            <mat-icon class="material-symbols-outlined">upload</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          {{ isLoading ? '' : 'carregar planilha de categorias' }}
        </button>
        <button mat-button (click)="downloadModelo()">
          <mat-icon class="material-symbols-outlined">download</mat-icon>
          download da planilha de exemplo
        </button>
      </div>
      <p class="instructions-text">
        Será considerado o campo ID em conjunto da Descrição para identificar se é novo ou atualização.<br />
        Selecione um arquivo no formato texto (.csv) separado por ";".<br />
        O arquivo deverá ser compatível com o layout fornecido pela ATS (veja ou gere exportando as suas).<br />
        O tamanho do arquivo não deve ultrapassar 2Mb.
      </p>
      @if (errorMessage) {
        <mat-error class="mb-3 d-block">
          <mat-icon class="align-middle">error</mat-icon> {{ errorMessage }}
        </mat-error>
      }
      <div class="table-section">
        <h3 class="table-title">Exemplo de planilha compatível com o Sistema ERP</h3>
        <div class="table-container">
          <table mat-table [dataSource]="dataSourceExample">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let e">{{ e.id }}</td>
            </ng-container>
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let e">{{ e.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoCategoriaFinanceiraDescricao">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoCategoriaFinanceiraDescricao }}</td>
            </ng-container>
            <ng-container matColumnDef="nomeCategoriaFinanceiraPai">
              <th mat-header-cell *matHeaderCellDef>Vincular a Categoria</th>
              <td mat-cell *matCellDef="let e">{{ e.nomeCategoriaFinanceiraPai }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoCategoriaDreDescricao">
              <th mat-header-cell *matHeaderCellDef>Grupo no DRE</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoCategoriaDreDescricao }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsExample"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsExample"></tr>
          </table>
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div class="dialog-content">
      <div class="validation-header mb-3">
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'todos'"
          (click)="aplicarFiltro('todos')">
          <span class="metric-label">todos</span>
          <strong class="metric-value">{{ getResumoTotal() }}</strong>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'novos'"
          (click)="aplicarFiltro('novos')">
          <span class="metric-label"><span class="dot dot-green"></span> novos</span>
          <span class="metric-value-sm">{{ getResumoNovos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'atualizados'"
          (click)="aplicarFiltro('atualizados')">
          <span class="metric-label"><span class="dot dot-blue"></span> atualizados</span>
          <span class="metric-value-sm">{{ getResumoAtualizados() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'avisos'"
          (click)="aplicarFiltro('avisos')">
          <span class="metric-label"><span class="dot dot-yellow"></span> advertências</span>
          <span class="metric-value-sm">{{ getResumoAvisos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'erros'"
          (click)="aplicarFiltro('erros')">
          <span class="metric-label"><span class="dot dot-red"></span> erros</span>
          <span class="metric-value-sm">{{ getResumoErros() }}</span>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="itemsFiltered">
          <ng-container matColumnDef="status" sticky>
            <th mat-header-cell *matHeaderCellDef class="w-status">Situação</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="w-status"
              [matTooltip]="getTooltip(element)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              <div class="status-dots">
                @if (element.acao == _acaoImportacaoEnum.Novo) {
                  <span class="dot dot-green"></span>
                }
                @if (element.acao == _acaoImportacaoEnum.Atualizar) {
                  <span class="dot dot-blue"></span>
                }
                @if (!element.isValido) {
                  <span class="dot dot-red"></span>
                }
                @if (element.isAlerta && element.isValido) {
                  <span class="dot dot-yellow"></span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.id }}
            </td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.descricao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tipoCategoriaFinanceiraDescricao">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tipoCategoriaFinanceiraDescricao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="nomeCategoriaFinanceiraPai">
            <th mat-header-cell *matHeaderCellDef>Vincular a Categoria</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.nomeCategoriaFinanceiraPai }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tipoCategoriaDreDescricao">
            <th mat-header-cell *matHeaderCellDef>Grupo no DRE</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tipoCategoriaDreDescricao }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsPreview"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsPreview"
            [ngClass]="getRowClass(row)"></tr>
        </table>
        @if (itemsFiltered.length === 0) {
          <div class="empty-state p-4 text-center text-muted">Nenhum item encontrado neste filtro.</div>
        }
      </div>
    </div>
  }

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <div class="actions-wrapper">
      @if (step === 1) {
        <button mat-stroked-button class="btn-secondary me-2 mobile-full-width" (click)="cancelar()">
          Cancelar
        </button>
      }

      @if (step === 2) {
        <button mat-stroked-button class="btn-secondary" (click)="voltarParaUpload()">
          <mat-icon>refresh</mat-icon> escolher outro arquivo
        </button>
        <div
          class="button-tooltip-wrapper mobile-full-width"
          [matTooltip]="getButtonTooltip()"
          [matTooltipDisabled]="!isImportDisabled">
          <button
            mat-flat-button
            class="btn-primary w-100"
            [disabled]="isImportDisabled || isLoading"
            (click)="confirmarImportacao()">
            @if (isLoading === true) {
              <mat-spinner [diameter]="20"></mat-spinner>
            } @else {
              <span class="material-symbols-outlined">check</span> meus dados estão corretos
            }
          </button>
        </div>
      }
    </div>
  </div>
</div>
